import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SimplebarAngularModule } from 'simplebar-angular';
import { DaveDoubleIconModule } from "../dave-double-icon/dave-double-icon.module";
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../dave-utils-module/app-filter-module/app-filter.module';
import { AutofocusModule } from '../directives/autofocus/autofocus.module';
import { ListCardDialogComponent } from './components/list-card-dialog/list-card-dialog.component';
import { DaveListCardComponent } from './dave-list-card.component';

@NgModule({
    declarations: [DaveListCardComponent, ListCardDialogComponent],
    imports: [
        CommonModule,
        MatCardModule,
        AppButtonModule,
        SimplebarAngularModule,
        MatTableModule,
        FontAwesomeModule,
        RouterModule,
        MatTooltipModule,
        MatDialogModule,
        MatSortModule,
        DaveLoadingModule,
        MatExpansionModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        AutofocusModule,
        DaveDoubleIconModule,
        MatCheckboxModule,
        AppFilterModule,
        MatBadgeModule,
    ],
    exports: [DaveListCardComponent],
})
export class DaveListCardModule {}
